import { render, staticRenderFns } from "./standard-policies.vue?vue&type=template&id=6d26925f"
import script from "./standard-policies.vue?vue&type=script&lang=ts"
export * from "./standard-policies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports